import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  VStack,
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { modal, button } from '../../themes/styles'

interface FormModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  onSubmit: () => void
  isLoading?: boolean
  size?: string
  children: React.ReactNode
  submitLabel?: string
  cancelLabel?: string
  closeOnOverlayClick?: boolean
}

export default function FormModal({
  isOpen,
  onClose,
  title,
  onSubmit,
  isLoading = false,
  size = 'lg',
  children,
  submitLabel,
  cancelLabel,
  closeOnOverlayClick = false,
}: FormModalProps) {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size={size}
      closeOnOverlayClick={closeOnOverlayClick}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader {...modal.header}>{title}</ModalHeader>
        <ModalCloseButton sx={modal.closeButton} />
        <ModalBody>
          <VStack spacing={4}>{children}</VStack>
        </ModalBody>
        <ModalFooter {...modal.footer}>
          <Button {...button.secondary} onClick={onClose}>
            {cancelLabel ?? t('common.actions.cancel')}
          </Button>
          <Button {...button.primary} onClick={onSubmit} isLoading={isLoading}>
            {submitLabel ?? t('common.actions.submit')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
